import { paletteVar } from "@platform/design-system";

/** Accent for the editors' "Add Option" controls. */
export const BRAND_PURPLE = paletteVar("primary-main", "#832A80");
